import wizardRiskCalculatorService from '../services/wizard-risk-calculator-service';

export default {
  install(Vue) {
    Vue.prototype.$wizardRiskCalculator = wizardRiskCalculatorService;
  }
};
